import Vue from 'vue';

import ClientPricesList from "./client-form/ClientPricesList.vue";
import ClientAndDepartmentSection from "./client-form/ClientAndDepartmentSection.vue";
import SubmitButtonsSection from "./client-form/SubmitButtonsSection.vue";
import NotesSection from "./client-form/NotesSection.vue";
import AgingOfReceivablesAndLiabilities from './aging-of-receivables-and-liabilities/AgingOfReceivablesAndLiabilities.vue';
import ContractForm from "./contract/ContractForm.vue";
import ContractInformation from "./contract/ContractInformation.vue";
import ContractorHistoryLocal from './contractor-history/ContractorHistoryLocal.vue';
import ModalConnectWith from './modal-connect-with/ModalConnectWith.vue';
import ModalGenerateBalance from './modal-generate-balance/ModalGenerateBalance.vue';
import UnallocatedPayments from './document-form/UnallocatedPayments.vue';
import GenerateTransferList from "./generate-transfer-list/GenerateTransferList.vue";
import SubmitButton from "./register/SubmitButton";
import PaymentsAndUnallocatedDocuments from './payments-and-unallocated-documents/PaymentsAndUnallocatedDocuments.vue';
import GroupForm from './payments/GroupForm.vue';
import Timer from "./session/Timer";
import PriceList from "./price-list/PriceListCreate.vue";
import ServiceAlert from "./service-alert/ServiceAlert";
import ServiceAlertContact from "./service-alert/ServiceAlertContact";
import ServiceAlertSection from "./service-alert/ServiceAlertSection";
import Create from './communication/messages/create/Create';
import Show from './communication/messages/show/Show';
import StockOpeningBalance from "../components/stock-opening-balance/StockOpeningBalance";
import GroupItems from "../components/stock-opening-balance/GroupItems";
import SellOrBuyAnalyze from "./sell-or-buy-analyze/SellOrBuyAnalyze";
import ChangeHistory from "./change-history/ChangeHistory";
import ChoosePositionForAnalyze from "./sell-or-buy-analyze/ChoosePositionForAnalyze";
import AnalyzeTabComponent from "./sell-or-buy-analyze/AnalyzeTabComponent";
import ListPositionComponent from "./sell-or-buy-analyze/ListPositionComponent";
import GlobalAnalyzeFilter from "./sell-or-buy-analyze/GlobalAnalyzeFilter";
import AnalyzeParameters from "./sell-or-buy-analyze/AnalyzeParameters";
import ModalAssingnToContractorGroup from "./sell-or-buy-analyze/ModalAssingnToContractorGroup";
import ModalCreateContractorGroup from "./sell-or-buy-analyze/ModalCreateContractorGroup";
import GroupedAndSortedDocuments from "./sell-or-buy-analyze/GroupedAndSortedDocuments";
import AnalyzeChart from "./sell-or-buy-analyze/AnalyzeChart";
import RadarChart from "./sell-or-buy-analyze/charts/RadarChart";
import ModalImportContractorGroup from "./sell-or-buy-analyze/ModalImportContractorGroup";
import ModalImportItemGroup from "./sell-or-buy-analyze/ModalImportItemGroup";
import ChartParameter from "./sell-or-buy-analyze/ChartParameter";
import LineBasic from "./sell-or-buy-analyze/charts/LineBasic";
import AreaBasic from "./sell-or-buy-analyze/charts/AreaBasic";
import ColumnWithDataLabels from "./sell-or-buy-analyze/charts/ColumnWithDataLabels";
import SimplePie from "./sell-or-buy-analyze/charts/SimplePie";
import SimpleDonut from "./sell-or-buy-analyze/charts/SimpleDonut";
import GradientDonut from "./sell-or-buy-analyze/charts/GradientDonut";
import SemiDonut from "./sell-or-buy-analyze/charts/SemiDonut";
import LineMany from "./sell-or-buy-analyze/charts/LineMany";
import LineSynchronized from "./sell-or-buy-analyze/charts/LineSynchronized";
import ModalEditDateGroup from "./sell-or-buy-analyze/ModalEditDateGroup";
import SummaryAnalyze from "./sell-or-buy-analyze/summary/SummaryAnalyze";
import BuyTable from "./sell-or-buy-analyze/summary/BuyTable";
import StoreAnalyzePattern from "./analyze-patterns/StoreAnalyzePattern.vue";
import ShowAnalyzePattern from "./analyze-patterns/ShowAnalyzePattern.vue";

Vue.component("client-prices-list", ClientPricesList);
Vue.component("client-and-department-section", ClientAndDepartmentSection);
Vue.component("submit-buttons-section", SubmitButtonsSection);
Vue.component("notes-section", NotesSection);
Vue.component("aging-of-receivables-and-liabilities", AgingOfReceivablesAndLiabilities);
Vue.component("contract-form", ContractForm);
Vue.component("stock-opening-balance", StockOpeningBalance)
Vue.component("group-items", GroupItems)
Vue.component("contract-information", ContractInformation);
Vue.component("contractor-history-local", ContractorHistoryLocal);
Vue.component("modal-connect-with", ModalConnectWith);
Vue.component("modal-generate-balance", ModalGenerateBalance);
Vue.component("unallocated-payments", UnallocatedPayments);
Vue.component("generate-transfer-list", GenerateTransferList);
Vue.component("submit-button", SubmitButton);
Vue.component("payments-and-unallocated-documents", PaymentsAndUnallocatedDocuments);
Vue.component("payment-group", GroupForm);
Vue.component('timer', Timer);
Vue.component('price-list-create', PriceList);
Vue.component('service-alert', ServiceAlert);
Vue.component('service-alert-contact', ServiceAlertContact);
Vue.component('service-alert-section', ServiceAlertSection);
Vue.component('create', Create);
Vue.component('show', Show);
Vue.component('sell-or-buy-analyze', SellOrBuyAnalyze)
Vue.component('change-history', ChangeHistory)
Vue.component('choose-position-for-analyze', ChoosePositionForAnalyze)
Vue.component('analyze-tab-component', AnalyzeTabComponent)
Vue.component('list-position-component', ListPositionComponent)
Vue.component('global-analyze-filter', GlobalAnalyzeFilter)
Vue.component('analyze-parameters', AnalyzeParameters)
Vue.component('modal-assign-to-contractor-group', ModalAssingnToContractorGroup)
Vue.component('modal-create-contractor-group', ModalCreateContractorGroup)
Vue.component('grouped-and-sorted-documents', GroupedAndSortedDocuments)
Vue.component('analyze-chart', AnalyzeChart)
Vue.component('radar-chart', RadarChart)
Vue.component('modal-import-contractor-group', ModalImportContractorGroup)
Vue.component('modal-import-item-group', ModalImportItemGroup)
Vue.component('chart-parameter', ChartParameter)
Vue.component('line-basic', LineBasic)
Vue.component('area-basic', AreaBasic)
Vue.component('column-with-data-labels', ColumnWithDataLabels)
Vue.component('bar-with-category-name-and-label-inside')
Vue.component('simple-pie', SimplePie)
Vue.component('simple-donut', SimpleDonut)
Vue.component('gradient-donut', GradientDonut)
Vue.component('semi-donut', SemiDonut)
Vue.component('line-many', LineMany)
Vue.component('line-synchronized', LineSynchronized)
Vue.component('modal-edit-date-group', ModalEditDateGroup)
Vue.component('summary-analyze', SummaryAnalyze)
Vue.component('buy-table', BuyTable)
Vue.component('store-analyze-pattern', StoreAnalyzePattern)
Vue.component('show-analyze-pattern', ShowAnalyzePattern)
